import "./style.css";

const WIN_PARAMS = 'scrollbars=0, resizable=1, menubar=0, left=100, top=100, width=550, height=440, toolbar=0, status=0';
const SOCIAL_URL = {
  TW: 'https://twitter.com/intent/tweet?',
  LN: 'https://www.linkedin.com/shareArticle?mini=true&',
  FB: 'https://www.facebook.com/sharer/sharer.php?',
};

export default class ShareLinks  {
  static selector = ".socials";

  constructor(block) {
    this.block = block;
    this.icons = this.block.querySelector('.socials__icons');
    if (this.icons) {
      this.twitterBtn = this.icons.querySelector('.socials__icons__twitter');
      this.linkedinBtn = this.icons.querySelector('.socials__icons__linkedin');
      this.facebookBtn = this.icons.querySelector('.socials__icons__facebook');
      this.url = this.twitterBtn.dataset.url;
    }
    this.twitterBtn  && this.twitterBtn.addEventListener('click', this.handleTwitterBtnClick);
    this.linkedinBtn &&  this.linkedinBtn.addEventListener('click', this.handleLinkedinBtnClick);
    this.facebookBtn && this.facebookBtn.addEventListener('click', this.handleFbBtnClick);
  }

  encodeParams = (obj) =>  {
    return Object.keys(obj).filter(function (k) {
      return typeof obj[k] !== 'undefined' && obj[k] !== '';
    }).map(function (k) {
      return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(obj[k]));
    }).join('&');
  }

  openShareLink = (params, url) => {
    const encodedParams = this.encodeParams(params)
    return window.open(`${url}`.concat(encodedParams), '_blank', WIN_PARAMS);
  }

  handleTwitterBtnClick = (e) => {
    const  params = {
      url: this.url,
    };
    this.openShareLink(params, SOCIAL_URL.TW);
  }

  handleLinkedinBtnClick = () => {
    const params ={
      url: this.url,
    };
    this.openShareLink(params, SOCIAL_URL.LN);
  }

  handleFbBtnClick = () => {
    var params = {
      kid_directed_site: '0',
      sdk: 'joey',
      u: this.url,
      display: 'popup',
      ref: 'plugin',
      src: 'share_button'
    };

    this.openShareLink(params, SOCIAL_URL.FB);
  }
}
